import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import Bookmarks, { getIsBookmarksHidden } from '../bookmarks';

import About from './About';
import Apps from './Apps';
import Counter from './Counter';
import GoogleAccount from './GoogleAccount';

import styles from './styles.module.scss';
import Feed from './Feed';
import ErrorBoundary from '../../../ErrorBoundary';
import Friends from '../../friends';
import { selectBookmarksNotificationHidden, selectOnboardingStep } from '../slice';

const Header: FunctionComponent = () => {
  const bookmarksNotificationHidden = useSelector(selectBookmarksNotificationHidden);
  const isOnboarding = !!useSelector(selectOnboardingStep);

  return (
    <header
      className={styles.pageHeader}
      style={{ paddingTop: '15px', zIndex: 200 }}
    >
      {/* Turn it on in a future release */}
      <Feed />
      <div className={styles.pageHeaderControls}>
        <div className={styles.cornerShadow} />

        {typeof window !== 'undefined' && !isOnboarding && (bookmarksNotificationHidden || getIsBookmarksHidden()) && <Bookmarks />}

        <About />
        {/* <a href="https://gmail.com">Gmail</a> */}
        <Counter />
        <Apps />

        {process.env.APP_PLATFORM === 'extension' && <GoogleAccount />}
      </div>

      <ErrorBoundary message={null} name="friends">
        <Friends />
      </ErrorBoundary>
    </header>
  );
};

export default Header;
